import React from "react";
import { Box, Typography } from "@mui/material";
import BarChartIcon from "@mui/icons-material/BarChart";

interface ChartEmptyStateProps {
  message?: string;
  height?: number | string;
}

const ChartEmptyState: React.FC<ChartEmptyStateProps> = ({
  message = "No data available",
  height = 300,
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: height,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: 3,
        backgroundColor: "#f8f9fa",
        borderRadius: "16px",
        border: "2px dashed #e0e0e0",
      }}
    >
      <BarChartIcon
        sx={{
          fontSize: 60,
          color: "#cbd5e1",
          marginBottom: 2,
        }}
      />
      <Typography
        variant="h6"
        sx={{
          color: "#94a3b8",
          fontSize: "16px",
          fontWeight: 500,
          fontFamily: "'Inter', sans-serif",
        }}
      >
        {message}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: "#cbd5e1",
          fontSize: "13px",
          marginTop: 1,
          fontFamily: "'Inter', sans-serif",
        }}
      >
        Data could not be loaded at this time
      </Typography>
    </Box>
  );
};

export default ChartEmptyState;
